/* ------------------------------------------------------------------
   Untitan - correctifs globaux

   1. Boutons [data-ut-scroll] : defilement doux vers le premier bundle.

   2. Miniatures des videos.
      L app "SS - Product Videos" construit ses lecteurs dans un <template>
      puis les clone en JS. Dans le DOM final, la vignette ne s affiche pas :
      le lecteur reste noir tant qu on ne clique pas.
      Correctif : on peint la vignette en background-image sur le <video>
      (elle reste visible tant qu aucune frame n est rendue), et si l attribut
      poster manque on reconstruit l URL Shopify a partir de celle de la video :
        /cdn/shop/videos/c/vp/<hash>/<hash>.HD-....mp4
     -> /cdn/shop/files/preview_images/<hash>.thumbnail.0000000000_1024x1024.jpg
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  /* ---------- 1. Defilement vers le bundle ---------- */
  function bindScroll() {
    document.querySelectorAll('[data-ut-scroll]').forEach(function (a) {
      if (a.dataset.utOn) return;
      a.dataset.utOn = '1';
      a.addEventListener('click', function (e) {
        var t =
          document.getElementById('ktb-top') ||
          document.querySelector('[data-ktb]') ||
          document.querySelector('product-info, #MainContent');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ---------- 2. Miniatures des videos ---------- */
  function sourceOf(v) {
    if (v.currentSrc) return v.currentSrc;
    if (v.getAttribute('src')) return v.getAttribute('src');
    if (v.dataset && v.dataset.src) return v.dataset.src;
    var s = v.querySelector('source');
    return s ? s.getAttribute('src') || s.dataset.src || '' : '';
  }

  function posterOf(v) {
    var p = v.getAttribute('poster');
    if (p) return p;

    var src = sourceOf(v) || '';
    var m = src.match(/\/videos\/c\/vp\/([0-9a-f]{32})\//i);
    if (!m) return null;

    var origin = src.split('/cdn/')[0];
    return (
      origin +
      '/cdn/shop/files/preview_images/' +
      m[1] +
      '.thumbnail.0000000000_1024x1024.jpg'
    );
  }

  function fix(v) {
    if (v.dataset.utFrame) return;
    v.dataset.utFrame = '1';

    var p = posterOf(v);
    if (p) {
      // La vignette reste visible tant que le lecteur ne peint pas d image.
      if (!v.getAttribute('poster')) v.setAttribute('poster', p);
      v.style.backgroundImage = 'url("' + p + '")';
      v.style.backgroundSize = 'cover';
      v.style.backgroundPosition = 'center';
      v.style.backgroundRepeat = 'no-repeat';
    }

    // loading="lazy" n existe pas sur <video> et bloque certains navigateurs.
    if (v.getAttribute('loading')) v.removeAttribute('loading');
    if (v.getAttribute('preload') === 'none') v.setAttribute('preload', 'metadata');
    v.muted = true;
    v.setAttribute('playsinline', '');

    if (v.hasAttribute('autoplay')) {
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    }
  }

  function scan() {
    document.querySelectorAll('video:not([data-ut-frame])').forEach(fix);
  }

  function boot() {
    bindScroll();
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  // L app clone ses lecteurs apres coup : on surveille les insertions.
  var pending = null;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(boot, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
